import { createSelector } from 'reselect';
import util from 'Utils';

const { geosAsObject } = util;

export const getWpIndicators = ({ data }) => data.indicators;
export const getDocIndicators = ({ table: { indicators = [] } = {} }) =>
  indicators.reduce((acc, x) => ({ ...acc, [x.id]: x }), {});

export const getRouter = ({ router }) => router;

export const getActiveGeos = ({ router }) => (
  'all' !== router.geos ?
    router.geos :
    Object.keys(geosAsObject())
);

export const getMegaIndicators = createSelector(
  [getWpIndicators],
  (indicators) => Object.keys(indicators)
    .filter((x) => Array.isArray(indicators[x].children))
    .reduce((acc, x) => ({ ...acc, [x]: indicators[x] }), {})
);

export const getNormalIndicators = createSelector(
  [getWpIndicators],
  (indicators) => Object.keys(indicators)
    .filter((x) => !Array.isArray(indicators[x].children))
    .reduce((acc, x) => ({ ...acc, [x]: indicators[x] }), {})
);

export const getRouteIndicators = createSelector(
  [getRouter],
  ({ indicators }) => (Array.isArray(indicators) ? indicators : [indicators]),
);

export const getRouteIndicatorsActiveData = createSelector(
  [getRouter, getRouteIndicators],
  (router, indicators) => indicators.reduce(
    (acc, x) => ({ ...acc, [x]: router[x] || {} }),
    {}
  )
);

export default {
  getWpIndicators,
  getDocIndicators,
  getMegaIndicators,
  getNormalIndicators,
  getRouter,
  getActiveGeos,
  getRouteIndicators,
  getRouteIndicatorsActiveData,
};



// WEBPACK FOOTER //
// ./app/selectors/table/basic.js